export default __webpack_public_path__ + "static/media/home-interior-design-testimonial-img03.2ffdd05b.jpg";